'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileDropdownMenu = require('./components/MobileDropdownMenu.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MobileDropdownMenu).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-mobile-dropdown-menu/lib/index.js
// module id = 632
// module chunks = 0 1 9 10 11